import React, { createContext, useContext, useState } from 'react';

// Create Context
const AppFlowEditorContext = createContext();

/**
 * Provider component for the editor context
 * @param {Object} props - The props including children components
 * @returns {JSX.Element} Provider wrapped around children
 */
export const AppFlowEditorProvider = ({ children }) => {
  const [editorField, setEditorField] = useState({
    name: 'name',
    value: 'value',
    label: 'label',
    title: 'title',
    row_no: '',
  });
  const [showModal, setShowModal] = useState(false);

  // Prepare the context value
  const contextValue = {
    editorField,
    setEditorField,
    showModal,
    setShowModal,
  };

  return (
    <AppFlowEditorContext.Provider value={contextValue}>
      {children}
    </AppFlowEditorContext.Provider>
  );
};

/**
 * Custom hook to use the editor context
 * @returns {Object} The editor context value
 */
export const useAppFlowEditor = () => {
  const context = useContext(AppFlowEditorContext);
  if (context === undefined) {
    throw new Error(
      'useAppFlowEditor must be used within an AppFlowEditorProvider',
    );
  }
  return context;
};
